import { Link } from "react-router-dom";
import type { Category } from "@/types/comic";
import Icon from "@/components/base/Icon";

interface CategoryCardProps {
  category: Category;
  count?: number;
}

export default function CategoryCard({ category, count }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.id}`}
      className="group flex items-start gap-3 p-4 rounded-lg border border-background-200 bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-primary-50/60"
    >
      <span className="w-11 h-11 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
        <Icon name={category.icon} className="w-5 h-5" />
      </span>
      <span className="min-w-0">
        <span className="flex items-center gap-2">
          <h3 className="font-heading text-base font-semibold text-foreground-950">
            {category.name}
          </h3>
          {typeof count === "number" && (
            <span className="text-xs text-foreground-400">{count} 部</span>
          )}
        </span>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{category.desc}</p>
      </span>
    </Link>
  );
}